import {
  ACTIVO_PAGOS_SUSCRIPCION,
  ALERT_FORM_PAGOS_SUSCRIPCION,
  ALERT_VIEW_PAGOS_SUSCRIPCION,
  ALL_PAGOS_SUSCRIPCION,
  LOADING_ALL_PAGOS_SUSCRIPCION,
} from './PagosSuscripcionReducer';
import {
  allPagosSuscripcionService,
  deletePagosSuscripcionService,
  onePagosSuscripcionService,
  savePagosSuscripcionService,
} from './PagosSuscripcionService';

export const allPagosSuscripcionAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_PAGOS_SUSCRIPCION, payload: true });
    const res = await allPagosSuscripcionService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_PAGOS_SUSCRIPCION, payload: res.data });
      dispatch({ type: LOADING_ALL_PAGOS_SUSCRIPCION, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_PAGOS_SUSCRIPCION, payload: false });
    return null;
  } catch (e) {
    alertPagosSuscripcion(dispatch, ALERT_VIEW_PAGOS_SUSCRIPCION, {
      severity: 'warning',
      title: e.message,
    });
  }
};

export const savePagosSuscripcionAction = async (
  dispatch,
  id,
  data,
  params,
) => {
  try {
    const res = await savePagosSuscripcionService(id, data);
    const success = res.status >= 200 && res.status < 203;
    if (success) {
      await allPagosSuscripcionAction(dispatch, params);
      alertPagosSuscripcion(dispatch, ALERT_VIEW_PAGOS_SUSCRIPCION, {
        severity: 'success',
        title:
          res.data.message ?? id
            ? 'La suscripción se ha actualizado correctamente'
            : 'La suscripción se ha registrado exitosamente',
      });
    } else {
      alertPagosSuscripcion(dispatch, ALERT_FORM_PAGOS_SUSCRIPCION, {
        severity: 'error',
        title: 'Error al momento de registrar la suscripción',
      });
    }
    return success;
  } catch (e) {
    alertPagosSuscripcion(dispatch, ALERT_FORM_PAGOS_SUSCRIPCION, {
      severity: 'warning',
      title: e.response?.data.message ?? e.message,
    });
  }
};

export const setActivoPagosSuscripcionAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PAGOS_SUSCRIPCION, payload: data });
};

export const onePagosSuscripcionAction = async (dispatch, id) => {
  const res = await onePagosSuscripcionService(id);
  if (res.status === 200) {
    await setActivoPagosSuscripcionAction(dispatch, res.data);
    return true;
  }
  return false;
};

export const alertPagosSuscripcion = (dispatch, type, payload) => {
  dispatch({ type, payload });
  setTimeout(() => {
    dispatch({ type, payload: null });
  }, 4500);
};

export const deletePagosSuscripcionAction = async (
  dispatch,
  id,
  params,
  setLoadingDelete,
) => {
  try {
    setLoadingDelete(true);
    const res = await deletePagosSuscripcionService(id);
    if (res.status === 200) {
      await setActivoPagosSuscripcionAction(dispatch, null);
      setLoadingDelete(false);
      await allPagosSuscripcionAction(dispatch, params);
      alertPagosSuscripcion(dispatch, ALERT_VIEW_PAGOS_SUSCRIPCION, {
        severity: 'info',
        title: res.data.message ?? 'PagosSuscripcion eliminada exitosamente',
      });
      return true;
    }
    setLoadingDelete(false);
    alertPagosSuscripcion(dispatch, ALERT_VIEW_PAGOS_SUSCRIPCION, {
      severity: 'error',
      title: res.data.message ?? 'Error al momento de eliminar la suscripción',
    });
    return false;
  } catch (e) {
    setLoadingDelete(false);
    alertPagosSuscripcion(dispatch, ALERT_VIEW_PAGOS_SUSCRIPCION, {
      severity: 'warning',
      title: e.response?.data.message ?? e.message,
    });
  }
};
